// extracted by mini-css-extract-plugin
export default {"main":"Main_main__krPka","flareAnimation":"Main_flareAnimation__fKUy8"};